export const messages = {
  confirmMessageEdit: 'Modificando questo filtro il credit check verrà azzerato. Confermi?',
  confirmMessageReset: 'Rimuovendo i filtri verrà azzerato il credit check. Confermi?',
};
